import React from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';

import { BaseComponentProps } from '@utils/types/baseComponents';
import WysiwygText from '@components/_shared/wysiwygText';
import defaultCancellationPolicy from './defaultCancellationPolicy';
import defaultNYCCancellationPolicy from './defaultNYCCancellationPolicy';
import SecurityDepositPolicy from './securityDepositPolicy';
import { ListingType } from '@utils/types/listing';

type Props = {
  cancellationPolicy: any;
  withSecurityDepositPolicy?: boolean;
  nycCancellationPolicy?: boolean;
  securityDepositPolicy?: ListingType['securityDepositPolicy'];
} & BaseComponentProps;

export function CancellationPolicy(props: Props) {
  const {
    cancellationPolicy,
    withSecurityDepositPolicy = false,
    nycCancellationPolicy = false,
    securityDepositPolicy,
    containerStyle,
  } = props;

  return (
    <div className={clsx([styles.cancellationPolicy, containerStyle])}>
      <h4 className={styles.title}>Cancellation Policy</h4>
      {cancellationPolicy ? (
        <WysiwygText content={cancellationPolicy} />
      ) : nycCancellationPolicy ? (
        defaultNYCCancellationPolicy
      ) : (
        defaultCancellationPolicy
      )}

      {withSecurityDepositPolicy && (
        <>
          <br />
          <h4 className={styles.title}>Security Deposit Policy</h4>
          <SecurityDepositPolicy
            containerStyle={styles.securityDepositPolicy}
            securityDepositPolicy={securityDepositPolicy}
          />
        </>
      )}
    </div>
  );
}
